
export default {
  productData: {
    serialNumber: 'DA-HMUF-003',
    name: 'Holzbalkendecken mit Unterdecken an Federschienen | Aufbau 3',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: '≥ 50',
          value: 'w-50'
        },
        {
          type: 'insulation',
          title: { de: 'Mineralwolledämmplatte MW<br>(<i>s‘</i> ≤ 8 MN/m<sup>3</sup>; Anwendungsgebiet DES-sh)' },
          output: '≥ 20',
          value: 'm-20'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 90 kg/m<sup>2</sup>), ggf. Rieselschutz' },
          output: '≥ 60',
          value: 'scsb-60'
        },
        {
          type: 'woodenPanel',
          title: { de: 'Holzwerkstoffplatte HW' },
          output: '22',
          value: 22
        },
        {
          type: 'supportingStructure',
          title: { de: 'Balken oder Stegträger' },
          output: '220',
          value: 'bs-220'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Hohlraumdämpfung' },
          output: '100',
          value: 'h-100'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Federschiene' },
          output: '27',
          value: 'f-27'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Gipsplatte GK' },
          output: '12,5',
          value: 'g-12.5'
        }
      ],
      sum: {
        output: '411,5', value: 411.5
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '31 (0)',
        value: 31
      },
      soundReductionIndex: { // Rw
        output: '≥ 70',
        value: 70
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,29',
        value: 0.29
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '258,4 [kg/m²]'
      }
    }
  },
  image: 'da-hmuf-003.png',
  pdf: 'Holzbalkendecken-mit-Unterdecken-an-Federschiene-Aufbau-3-DA-HMUF-003-Rev03.pdf'
}
